"use client";

import { c as _c } from "react/compiler-runtime";
import { useAnimationConfig } from "@/context/AnimationContext";
import ReaderModeView from "@/components/ReaderModeView";
interface ReaderModeWrapperProps {
  children: React.ReactNode;
  // The full dictionary from the server component (layout)
  dict: Record<string, Record<string, unknown>>;
  locale: string;
}
export default function ReaderModeWrapper(t0) {
  const $ = _c(6);
  const {
    children,
    dict,
    locale
  } = t0;
  const {
    isReaderMode,
    toggleReaderMode
  } = useAnimationConfig();
  if (isReaderMode) {
    let t1;
    if ($[0] !== dict || $[1] !== locale || $[2] !== toggleReaderMode) {
      t1 = <ReaderModeView dict={dict} locale={locale} onExit={toggleReaderMode} />;
      $[0] = dict;
      $[1] = locale;
      $[2] = toggleReaderMode;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== children) {
    t1 = <>{children}</>;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}